import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import './Vendor.css'
import { useDispatch, useSelector } from "react-redux";
import { loadCategories } from '../../Redux/Actions/ActionCategories';
import Select from 'react-select';
import { loadDays, loadSubCategoryById } from '../../Redux/Actions/ActionSubCategory';
import GoogleMapReact from "google-map-react";
import Geocode from 'react-geocode';
import { postVendor } from '../../Redux/Actions/ActionVendors';
import { loadSocial } from '../../Redux/Actions/ActionSocial';

Geocode.setApiKey("AIzaSyBTe3zscwtZeS24s2izez3M1aj7LTJdUx0");

const AnyReactComponent = ({ text }) => <div><i className='fa fa-map-marker map_marker' ></i></div>;

function AddVen() {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [loadBtn, setloadBtn] = useState(false)
    const [name, setname] = useState('')
    const [name_ar, setname_ar] = useState('')
    const [description, setdescription] = useState('')
    const [description_ar, setdescription_ar] = useState('')
    const [phone, setphone] = useState('')
    const [phone1, setphone1] = useState('')
    const [email, setemail] = useState('')
    const [address, setaddress] = useState('')
    const [address1, setaddress1] = useState('')
    const [start_date, setstart_date] = useState('')
    const [expire_date, setexpire_date] = useState('')
    const [image, setimage] = useState('')
    const [custom_date, setcustom_date] = useState('')
    const social = useSelector(state => state.social_media.social)
    const dayss = useSelector(state => state.sub_category.dayss)
    const categories = useSelector(state => state.Categories.categories)
    const subCatById = useSelector(state => state.sub_category.subCatById)
    const [category_id, setcategory_id] = useState(null)
    const [options, setoptions] = useState([])
    const [optionsSub, setoptionsSub] = useState([])
    const [subcategories, setSubcategories] = useState([]);
    const [location, setLocation] = useState({ map_lat: null, map_lng: null });
    const [fields, setFields] = useState([{ dayId: '', openAt: '', closeAt: '' }]);
    const [social_media, setsocial_media] = useState([{ socId: '', link: '' }]);
    useEffect(() => {
        dispatch(loadCategories())
        dispatch(loadDays())
        dispatch(loadSocial())
    }, [])
    useEffect(() => {
        console.log("one")
        dispatch(loadCategories())
        if (category_id != null) {
            console.log("two")
            console.log(category_id)
            dispatch(loadSubCategoryById(category_id))
        }
    }, [category_id])
    useEffect(() => {
        if (categories.length > 0) {
            const updatedOptions = categories.map(category => ({
                value: category.id,
                label: category.name,
            }));
            setoptions(updatedOptions);
        }
        if (subCatById.length >= 0) {
            const updatedOptions = subCatById.map(sub => ({
                value: sub.id,
                label: sub.name,
            }));
            setoptionsSub(updatedOptions);
        }
    }, [categories, subCatById])
    const setcategory_idd = (selectedOption) => {
        if (selectedOption) {
            const value = selectedOption.value;
            setcategory_id(value);
        } else {
            setcategory_id(null);
        }
    }
    const handleSelectChange = (selectedOptions) => {
        const selectedValues = selectedOptions.map(option => option.value);
        setSubcategories(selectedValues);
    };
    const test = event => {
        event.preventDefault();
        /*console.log(name)
        console.log(name_ar)
        console.log(description)
        console.log(description_ar)
        console.log(phone)
        console.log(email)
        console.log(address)
        console.log(address1)
        console.log(start_date)
        console.log(expire_date)
        console.log(image)
        console.log(custom_date)
        console.log(subcategories)
        console.log(location.map_lat)
        console.log(location.map_lng)
        console.log(fields)
        console.log(social_media)*/
        dispatch(postVendor(name , name_ar , description , description_ar , phone, phone1, email, address, address1 , start_date , 
            expire_date , image , custom_date , subcategories, location.map_lat , location.map_lng , fields , social_media,category_id , setloadBtn))
    }
    const handleMapClick = (event) => {
        const { lat, lng } = event;
        setLocation({ map_lat: lat, map_lng: lng });

        Geocode.fromLatLng(lat, lng).then(
            (response) => {
                const address = response.results[0].formatted_address;
                console.log(address);
            },
            (error) => {
                console.error(error);
            }
        );
    };
    const handleApiLoaded = (map, maps) => {
        map.setOptions({ scrollwheel: false });
    }
    const handleFieldChange = (index, field, value) => {
        const updatedFields = [...fields];
        updatedFields[index][field] = value;
        setFields(updatedFields);
    };

    const addField = event => {
        event.preventDefault();
        setFields([...fields, { dayId: '', openAt: '', closeAt: '' }]);
    };
    const handleSocialChange = (index, field, value) => {
        const updatedFields = [...social_media];
        updatedFields[index][field] = value;
        setsocial_media(updatedFields);
    };
    const addSocial = event => {
        event.preventDefault();
        setsocial_media([...social_media, { socId: '', link: '' }]);
    };
    return (
        <main>
            <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <h2>{t('addvendor')}</h2>
            </div>
            <div className='addVen' >
                <form>
                    <div className='input_row1' >
                        <div className='one_input_row1'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('name_en')}</span>
                            </div>
                            <input type="text" placeholder={t('name_en')} onChange={(e)=> setname(e.target.value)} />
                        </div>
                        <div className='one_input_row1' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('name_ar')}</span>
                            </div>
                            <input type="text" placeholder={t('name_ar')} onChange={(e)=> setname_ar(e.target.value)}  />
                        </div>
                    </div>
                    <div className='input_row1' >
                        <div className='one_input_row1'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('desc_en')}</span>
                            </div>
                            <input type="text" placeholder={t('desc_en')} onChange={(e)=> setdescription(e.target.value)}  />
                        </div>
                        <div className='one_input_row1' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('desc_ar')}</span>
                            </div>
                            <input type="text" placeholder={t('desc_ar')} onChange={(e)=> setdescription_ar(e.target.value)}  />
                        </div>
                    </div>
                    <div className='input_row1' >
                        <div className='one_input_row1'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('phone')}</span>
                            </div>
                            <input type="text" placeholder={t('phone')} onChange={(e)=> setphone(e.target.value)}  />
                        </div>
                        <div className='one_input_row1'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('phone1')}</span>
                            </div>
                            <input type="text" placeholder={t('phone1')} onChange={(e)=> setphone1(e.target.value)}  />
                        </div>
                        <div className='one_input_row1' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('email')}</span>
                            </div>
                            <input type="text" placeholder={t('email')} onChange={(e)=> setemail(e.target.value)}  />
                        </div>
                    </div>
                    <div className='input_row1' >
                        <div className='one_input_row1'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('address')}</span>
                            </div>
                            <input type="text" placeholder={t('address')} onChange={(e)=> setaddress(e.target.value)}  />
                        </div>
                        <div className='one_input_row1' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('address1')}</span>
                            </div>
                            <input type="text" placeholder={t('address1')} onChange={(e)=> setaddress1(e.target.value)}  />
                        </div>
                    </div>
                    <div className='mapp'>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "AIzaSyBTe3zscwtZeS24s2izez3M1aj7LTJdUx0" }}
                            defaultCenter={{ lat: 33.510414, lng: 36.278336 }}
                            defaultZoom={12}
                            onClick={handleMapClick}
                            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                        >
                            <AnyReactComponent
                                lat={location.map_lat}
                                lng={location.map_lng}
                                text="My Marker"
                            />
                        </GoogleMapReact>
                    </div>
                    <div className='input_row1' >
                        <div className='one_input_row1'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('start_date')}</span>
                            </div>
                            <input type="date" onChange={(e)=> setstart_date(e.target.value)}  />
                        </div>
                        <div className='one_input_row1' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('expire_date')}</span>
                            </div>
                            <input type="date" onChange={(e)=> setexpire_date(e.target.value)}  />
                        </div>
                    </div>

                    <div className='input_row1' >
                        <div className='one_input_row1'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('categories')}</span>
                            </div>
                            <Select
                                defaultValue={category_id}
                                onChange={setcategory_idd}
                                options={options}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused ? 'grey' : 'rgb(214, 214, 214)',
                                        borderRadius: "10px",
                                        margin: "0px 10px",
                                        width: "100%"
                                    }),
                                }}
                            />
                        </div>
                        <div className='one_input_row1' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('image')}</span>
                            </div>
                            <input type="file" onChange={(e)=> setimage(e.target.files[0])}  />
                        </div>
                    </div>
                    <div className='input_row1'>
                        <div className='one_input_row1'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil'></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""}>{t('subCategory')}</span>
                            </div>
                            <Select
                                options={optionsSub}
                                isMulti
                                value={subcategories.map(value => ({ value, label: optionsSub.find(opt => opt.value === value)?.label }))}
                                onChange={handleSelectChange}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused ? 'grey' : 'rgb(214, 214, 214)',
                                        borderRadius: "10px",
                                        margin: "0px 10px",
                                        width: "100%"
                                    }),
                                }}
                            />
                        </div>
                        <div className='one_input_row1' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('custom_date')}</span>
                            </div>
                            <input type="date" onChange={(e)=> setcustom_date(e.target.value)}  />
                        </div>
                    </div>
                    {fields.map((field, index) => (
                        <>
                            <div className='input_row1' >
                                <div className='one_input_row1'>
                                    <div className='Gen_icon'>
                                        <i className='fa fa-pencil' ></i>
                                        <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('days')}</span>
                                    </div>
                                    <select onChange={(e) => handleFieldChange(index, 'dayId', e.target.value)} >
                                        <option disabled="disabled" selected="selected">--Please choose an option--</option>
                                        {
                                            dayss.map((dd) => {
                                                return (
                                                    <option value={dd.id} >{dd.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className='one_input_row1' >
                                    <div className='Gen_icon'>
                                        <i className='fa fa-pencil' ></i>
                                        <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('open_at')}</span>
                                    </div>
                                    <input type="time" onChange={(e) => handleFieldChange(index, 'openAt', e.target.value)} />
                                </div>
                            </div>
                            <div className='input_row1' >
                                <div className='one_input_row1' >
                                    <div className='Gen_icon'>
                                        <i className='fa fa-pencil' ></i>
                                        <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('close_at')}</span>
                                    </div>
                                    <input type="time" onChange={(e) => handleFieldChange(index, 'closeAt', e.target.value)} />
                                </div>
                            </div>
                        </>))}
                    <div className='input_row1' >
                        <button onClick={addField} className='add_more' >Add More Day</button>
                    </div>
                    {
                        social_media.map((ss, index) => (
                            <div className='input_row1' >
                                <div className='one_input_row1'>
                                    <div className='Gen_icon'>
                                        <i className='fa fa-pencil' ></i>
                                        <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('socialmed')}</span>
                                    </div>
                                    <select onChange={(e) => handleSocialChange(index, 'socId', e.target.value)} >
                                        <option disabled="disabled" selected="selected">--Please choose an option--</option>
                                        {
                                            social.map((dd) => {
                                                return (
                                                    <option value={dd.id} >{dd.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className='one_input_row1' >
                                    <div className='Gen_icon'>
                                        <i className='fa fa-pencil' ></i>
                                        <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('link')}</span>
                                    </div>
                                    <input type="text" onChange={(e) => handleSocialChange(index, 'link', e.target.value)} />
                                </div>
                            </div>
                        ))
                    }
                    <div className='input_row1' >
                        <button onClick={addSocial} className='add_more' >Add More Social Mdia</button>
                    </div>
                    <button className='send_btn' onClick={test} >
                        {
                            loadBtn ? "Loading ..." : "send"
                        }
                    </button>
                </form>
            </div>
        </main>
    )
}

export default AddVen